import axios from "axios";
import { URL_ORQUESTRADOR } from "../../shared/util/perfis/exportEnvs";
import { emailMatch } from "../../shared/util/regex/emailCheck";
import ReCAPTCHA from "react-google-recaptcha";
import toast from "react-hot-toast";
import { Dispatch, SetStateAction } from "react";
import { ResetPasswordErrorEnum } from "constants/EnumResetPasswordError";
import { NavigateFunction } from "react-router-dom";
import { http } from "shared/util/http";
import { api } from "constants/RotasAPI";
import { RecaptchaDTO } from "types/dto/ReCaptchaDTO";
import { RequestAuthenticate } from "types/request/RequestAuthenticate";
import { usePostAuthenticate } from "hooks/login/usePostAuthenticate";

const LoginFunctions = () => {
  const { mutateAsync: postLogin } = usePostAuthenticate();

  async function login(
    username: string,
    password: string,
    ip: string,
    renderError: Dispatch<SetStateAction<boolean>>
  ) {
    const request: RequestAuthenticate = { username, password, remember: false, ip };
    try {
      await postLogin(request);
    } catch (error) {
      renderError(true);
    }
  }

  const validateUsernameField = (username: string) => {
    return emailMatch(username) && username.trim() !== "";
  };

  const validatePasswordField = (password: string) => {
    return password.trim() !== "" && password.length >= 4 && password.length <= 100;
  };

  const handleVerifyRecaptcha = (
    response: string | null,
    handleRecaptchaIsValid: (value: boolean) => void,
    recaptcha: ReCAPTCHA | null
  ) => {
    http.post<RecaptchaDTO>(api.getRecaptcha, { response }).then(
      (resp) => {
        if (resp.data.success) {
          handleRecaptchaIsValid(true);
        } else {
          handleRecaptchaIsValid(false);
          recaptcha?.reset();
        }
      },
      (erro) => recaptcha?.reset()
    );
  };

  const validateResetPassword = (
    navigate: NavigateFunction,
    urlToken: string,
    username: string,
    password: string,
    confirmPassword: string,
    setError: (value: SetStateAction<boolean>) => void
  ) => {
    if (password !== confirmPassword) {
      setError(true);
      return;
    }

    const validation = {
      username: username.trim() !== "",
      password: password.trim() !== "",
      confirmPassword: confirmPassword.trim() !== "",
      sizeIsValid: password.length >= 5 && confirmPassword.length >= 5,
    };

    if (
      validation.username &&
      validation.password &&
      validation.confirmPassword &&
      validation.sizeIsValid
    ) {
      let request = {
        email: username,
        password: password,
        confirmPassword: confirmPassword,
        resetKey: urlToken,
      };
      axios
        .post(`${URL_ORQUESTRADOR}/api/usuario/confirmar-senha`, request)
        .then((response) => {
          toast.success("Senha alterada com sucesso.");
          navigate("/v2/login", { replace: true });
        })
        .catch((error) => {
          toast.error("Erro ao alterar senha.");
        });
    } else {
      console.error(validation);
      toast.error("Erro ao criar senha.");
    }
  };

  const onBlurPassword = (
    password: string,
    setPassword: (value: SetStateAction<ResetPasswordErrorEnum | undefined>) => void
  ) => {
    const validateConfirmPassword = () => {
      if (password === "") return ResetPasswordErrorEnum.VALOR_VAZIO;
      if (password.length < 5) return ResetPasswordErrorEnum.TAMANHO_MININO;
      return undefined;
    };

    setPassword(validateConfirmPassword());
  };

  const onBlurConfirmPassword = (
    confirmPassword: string,
    setConfirmPassword: (value: SetStateAction<ResetPasswordErrorEnum | undefined>) => void
  ) => {
    const validateConfirmPassword = () => {
      if (confirmPassword === "") return ResetPasswordErrorEnum.VALOR_VAZIO_CONFIRMAR_SENHA;
      if (confirmPassword.length < 5) return ResetPasswordErrorEnum.TAMANHO_MININO_CONFIRMAR_SENHA;
      return undefined;
    };

    setConfirmPassword(validateConfirmPassword());
  };

  const handleStartTime = (
    setDisableLoginButton: Dispatch<SetStateAction<boolean>>,
    timer: number,
    setTimer: Dispatch<SetStateAction<number>>,
    setAttempt: Dispatch<SetStateAction<number>>,
    setRenderErro: Dispatch<SetStateAction<boolean>>,
    setIsAttemptLimit: Dispatch<SetStateAction<boolean>>
  ) => {
    const t = setInterval(() => {
      if (timer < 1) {
        setAttempt(0);
        setDisableLoginButton(false);
        setTimer(30);
        setRenderErro(false);
        setIsAttemptLimit(false);
        clearInterval(t);
      } else {
        setDisableLoginButton(true);
        setIsAttemptLimit(true);
        setRenderErro(true);
        let segs: number = (timer -= 1);
        setTimer(segs);
      }
    }, 1000);
  };

  return {
    login,
    validateUsernameField,
    validatePasswordField,
    handleVerifyRecaptcha,
    validateResetPassword,
    onBlurPassword,
    onBlurConfirmPassword,
    handleStartTime,
  };
};

export default LoginFunctions;
